import { render } from "./event4.vue?vue&type=template&id=1fe057cd&scoped=true"
import script from "./event4.vue?vue&type=script&lang=js"
export * from "./event4.vue?vue&type=script&lang=js"

import "./event4.vue?vue&type=style&index=0&id=1fe057cd&lang=less&scoped=true"
import "./event4.vue?vue&type=style&index=1&id=1fe057cd&lang=less"

import exportComponent from "D:\\myWorkspace\\CoreWeb\\MyNews\\ClientApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe057cd"]])

export default __exports__